import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { ignoreOnclickoutsideClassName } from '../../../constants/ui';

export default class AdvancedFilterButton extends PureComponent {
  render () {
    return (
      <button
        className={`advanced-filter-btn ${this.props.isFilterApplied && 'active'} ${ignoreOnclickoutsideClassName}`}
        onClick={this.props.onClick}
      >
        <span className='filter-icon fa-filter'>
          <FontAwesomeIcon icon={faFilter} />
        </span>
        <span className='text-uppercase'>Advanced Filter</span>
        <span className='filter-icon'>
          <FontAwesomeIcon icon={faCaretDown} />
        </span>
      </button>
    );
  }
}

AdvancedFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isFilterApplied: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/common/AdvancedFilter/AdvancedFilterButton.js